import type { CSSProperties } from 'react';
import { PLAYER_THEME_VARS, PLAYER_UI, playerPanel } from '../../theme';

/** The NPC family uses the shared material and semantic states, never its own palette. */
export const NPC_UI_VARS = {
  ...PLAYER_THEME_VARS, '--npc-danger': PLAYER_UI.danger, '--npc-success': PLAYER_UI.success,
} as CSSProperties;

export function npcPanel(): CSSProperties {
  return { ...playerPanel(), ...NPC_UI_VARS };
}
